export interface IMatchRunResults {
    deepestChainDepth: number,
    nddOneWayCount: number,
    ddOneWaysConfigured: number,
    totalOneWays: number,
    chainStartCount: number,
}